const mockFunc = (...args) => console.log(args);

export const getTelegramApi = () => {
  if (window?.Telegram?.WebApp?.initData !== "") {
    console.log(`window?.Telegram?.WebApp?.initData !== ""`)
    return window.Telegram.WebApp;
  } else {
    console.log(`window?.Telegram?.WebApp?.initData === ""`)
    return {
      initData: 'query_id=AAGdp14MAAAAAJ2nXgyrs727&user=%7B%22id%22%3A207529885%2C%22first_name%22%3A%22Kirill%22%2C%22last_name%22%3A%22Sidorov%22%2C%22username%22%3A%22sidorovkv%22%2C%22language_code%22%3A%22ru%22%2C%22allows_write_to_pm%22%3Atrue%7D&auth_date=1715742794&hash=4b615479813ecb1c49f6b6688699f5c7a4b91e552d58db0e6ac5f2157ccb0340',
      // initData: 'query_id=xxx&user=%7B%22id%22%3A207529885%2C%22&hash=zzz',
      setHeaderColor: mockFunc,
      expand: mockFunc,
      ready: mockFunc,
      close: mockFunc,
      sendData: mockFunc,
      onEvent: mockFunc,
      offEvent: mockFunc,
      enableClosingConfirmation: mockFunc,
      disableClosingConfirmation: mockFunc,
      SettingsButton: {
        onClick: mockFunc,
        offClick: mockFunc,
        show: mockFunc
      }
    }
  }
}




